import type { Face } from './crossSection';

/**
 * 面ボタンの小さな立方体図（等方射影）を SVG 文字列で生成する。
 * 「＋」の面は (+,+,+) 側から、「−」の面は (−,−,−) 側から見た図を使い、
 * 6 面のいずれでも「自分に対応する面」を強調表示できる。
 */

type Corner = [number, number, number];

/** 各面の 4 角（0/1 立方体上の座標） */
const FACE_CORNERS: Record<Face, Corner[]> = {
  'x-': [[0, 0, 0], [0, 1, 0], [0, 1, 1], [0, 0, 1]],
  'x+': [[1, 0, 0], [1, 1, 0], [1, 1, 1], [1, 0, 1]],
  'y-': [[0, 0, 0], [1, 0, 0], [1, 0, 1], [0, 0, 1]],
  'y+': [[0, 1, 0], [1, 1, 0], [1, 1, 1], [0, 1, 1]],
  'z-': [[0, 0, 0], [1, 0, 0], [1, 1, 0], [0, 1, 0]],
  'z+': [[0, 0, 1], [1, 0, 1], [1, 1, 1], [0, 1, 1]],
};

/** その面が見える 3 つの面（視点を決定する） */
const VISIBLE_FACES: Record<Face, Face[]> = {
  'x-': ['x-', 'y-', 'z-'],
  'x+': ['x+', 'y+', 'z+'],
  'y-': ['x-', 'y-', 'z-'],
  'y+': ['x+', 'y+', 'z+'],
  'z-': ['x-', 'y-', 'z-'],
  'z+': ['x+', 'y+', 'z+'],
};

function project(x: number, y: number, z: number, mirror: boolean): [number, number] {
  let sx = (x - z) * 0.866;
  let sy = (x + z) * 0.5 - y;
  if (mirror) {
    sx = -sx;
    sy = -sy;
  }
  return [sx, sy];
}

export function faceCubeIcon(face: Face): string {
  const mirror = face.endsWith('-');
  const pt = ([x, y, z]: Corner): string => {
    const [sx, sy] = project(x, y, z, mirror);
    return `${(12 + sx * 10).toFixed(1)},${(12 + sy * 10).toFixed(1)}`;
  };
  const poly = (f: Face): string => FACE_CORNERS[f].map(pt).join(' ');
  const body = VISIBLE_FACES[face]
    .map((f) => {
      const fill = f === face ? '#3557b7' : '#232a38';
      return `<polygon points="${poly(f)}" fill="${fill}" stroke="#4a5568" stroke-width="0.7"/>`;
    })
    .join('');
  return `<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">${body}</svg>`;
}
